import { fade, palette } from './colors';

export const outlines = {
  control: '1px solid',
};

const controlOutlineColors = {
  // Destructive controls, vivid
  // // Light
  destructiveVividInitialLight: fade(palette.controlStrokeVividDestructiveLight, 1),
  destructiveVividHoveredLight: fade(palette.controlStrokeVividDestructiveLight, 1),
  destructiveVividFocusedLight: palette.controlStrokeVividDestructiveFocusedLight,
  destructiveVividDisabledLight: fade(palette.controlStrokeVividDestructiveLight, 0.85),
  // // Dark
  destructiveVividInitialDark: fade(palette.controlStrokeVividDestructiveDark, 0.85),
  destructiveVividHoveredDark: fade(palette.controlStrokeVividDestructiveDark, 0.9),
  destructiveVividFocusedDark: palette.controlStrokeVividDestructiveFocusedDark,
  destructiveVividDisabledDark: fade(palette.controlStrokeVividDestructiveDark, 0.5),

  // Destructive controls, muted
  // // Light
  destructiveMutedInitialLight: fade(palette.controlStrokeMutedDestructiveLight, 0.7),
  destructiveMutedHoveredLight: fade(palette.controlStrokeMutedDestructiveLight, 1),
  destructiveMutedFocusedLight: palette.controlStrokeMutedDestructiveLight,
  destructiveMutedDisabledLight: fade(palette.controlStrokeMutedDestructiveLight, 0.7),
  // // Dark
  destructiveMutedInitialDark: fade(palette.controlStrokeMutedDestructiveDark, 0.9),
  destructiveMutedHoveredDark: fade(palette.controlStrokeMutedDestructiveDark, 1),
  destructiveMutedFocusedDark: palette.controlStrokeMutedDestructiveDark,
  destructiveMutedDisabledDark: fade(palette.controlStrokeMutedDestructiveDark, 0.7),

  // Primary controls, vivid
  // // Light
  primaryVividInitialLight: fade(palette.controlStrokeVividPrimaryLight, 0.85),
  primaryVividHoveredLight: fade(palette.controlStrokeVividPrimaryLight, 0.95),
  primaryVividFocusedLight: palette.controlStrokeVividPrimaryFocusedLight,
  primaryVividDisabledLight: fade(palette.controlStrokeVividPrimaryLight, 0.85),
  // // Dark
  primaryVividInitialDark: fade(palette.controlStrokeVividPrimaryDark, 0.9),
  primaryVividHoveredDark: fade(palette.controlStrokeVividPrimaryDark, 1),
  primaryVividFocusedDark: palette.controlStrokeVividPrimaryFocusedDark,
  primaryVividDisabledDark: fade(palette.controlStrokeVividPrimaryDark, 0.7),

  // Primary controls, muted
  // // Light
  primaryMutedInitialLight: fade(palette.controlStrokeMutedPrimaryLight, 0.7),
  primaryMutedHoveredLight: fade(palette.controlStrokeMutedPrimaryLight, 1),
  primaryMutedFocusedLight: palette.controlStrokeMutedPrimaryLight,
  primaryMutedDisabledLight: fade(palette.controlStrokeMutedPrimaryLight, 0.7),
  // // Dark
  primaryMutedInitialDark: fade(palette.controlStrokeMutedPrimaryDark, 0.7),
  primaryMutedHoveredDark: fade(palette.controlStrokeMutedPrimaryDark, 1),
  primaryMutedFocusedDark: palette.controlStrokeMutedPrimaryDark,
  primaryMutedDisabledDark: fade(palette.controlStrokeMutedPrimaryDark, 0.7),

  // Secondary controls, vivid
  // // Light
  secondaryVividInitialLight: fade(palette.controlStrokeRaisedLight, 0.24),
  secondaryVividHoveredLight: fade(palette.controlStrokeRaisedLight, 0.3),
  secondaryVividFocusedLight: palette.controlStrokeRaisedFocusedLight,
  secondaryVividDisabledLight: fade(palette.controlStrokeRaisedLight, 0.18),
  // // Dark
  secondaryVividInitialDark: fade(palette.controlStrokeRaisedDark, 0.6),
  secondaryVividHoveredDark: fade(palette.controlStrokeRaisedDark, 0.7),
  secondaryVividFocusedDark: palette.controlStrokeRaisedFocusedDark,
  secondaryVividDisabledDark: fade(palette.controlStrokeRaisedDark, 0.6),

  // Secondary controls, muted
  // // Light
  secondaryMutedInitialLight: fade(palette.controlStrokeBaseLight, 0.12),
  secondaryMutedHoveredLight: fade(palette.controlStrokeBaseLight, 0.24),
  secondaryMutedFocusedLight: palette.controlStrokeBaseFocusedLight,
  secondaryMutedDisabledLight: fade(palette.controlStrokeBaseLight, 0.3),
  // // Dark
  secondaryMutedInitialDark: fade(palette.controlStrokeBaseDark, 0.2),
  secondaryMutedHoveredDark: fade(palette.controlStrokeBaseDark, 0.34),
  secondaryMutedFocusedDark: fade(palette.controlStrokeBaseFocusedDark, 0.34),
  secondaryMutedDisabledDark: fade(palette.controlStrokeBaseDark, 0.15),

  // Internal controls
  // // Light
  internalInitialLight: fade(palette.controlStrokeInternalLight, 0.12),
  internalHoveredLight: fade(palette.controlStrokeInternalLight, 0.24),
  internalFocusedLight: palette.controlStrokeInternalFocusedLight,
  internalDisabledLight: fade(palette.controlStrokeInternalLight, 0.3),
  // // Dark
  internalInitialDark: fade(palette.controlStrokeInternalDark, 0.44),
  internalHoveredDark: fade(palette.controlStrokeInternalDark, 0.66),
  internalFocusedDark: fade(palette.controlStrokeInternalFocusedDark, 0.6),
  internalDisabledDark: fade(palette.controlStrokeInternalDark, 0.36),

  // Raised controls
  // // Light
  raisedInitialLight: fade(palette.controlStrokeRaisedLight, 0.24),
  raisedHoveredLight: fade(palette.controlStrokeRaisedLight, 0.3),
  raisedFocusedLight: palette.controlStrokeRaisedFocusedLight,
  raisedDisabledLight: fade(palette.controlStrokeRaisedLight, 0.18),
  // // Dark
  raisedInitialDark: fade(palette.controlStrokeRaisedDark, 0.5),
  raisedHoveredDark: fade(palette.controlStrokeRaisedDark, 0.7),
  raisedFocusedDark: palette.controlStrokeRaisedFocusedDark,
  raisedDisabledDark: fade(palette.controlStrokeRaisedDark, 0.5),
};

export const outlineColors = {
  control: controlOutlineColors,
};
